import React, { memo } from 'react'
import { string } from 'prop-types'

export const ChevronBlock = memo(({ fill = '#fbb03b', width = '45', height = '58.616' }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			width={width}
			height={height}
			viewBox="0 0 45 58.616"
		>
			<g transform="matrix(1, 0, 0, 1, 0, 0)">
				<path
					fill={fill}
					d="M741.409,248.069l13.325-13.325a.411.411,0,0,0,0-.581l-6.281-6.281a.411.411,0,0,0-.581,0l-19.9,19.9a.411.411,0,0,0,0,.581l19.9,19.9a.411.411,0,0,0,.581,0l6.281-6.281a.411.411,0,0,0,0-.581Z"
					transform="translate(763.85 274.38) rotate(180)"
				/>
			</g>
		</svg>
	)
})

ChevronBlock.propTypes = {
	fill: string,
	height: string,
	width: string,
}
